import api from 'utils/api';
import { updateBusinessKeywords } from './actions';

export default async function addBusinessKeywords(businessId, existingKeywords, keywords, dispatch) {
  const merged = [...new Set([...existingKeywords, ...keywords])];
  await api.put(`/business/${businessId}/keywords`, { keywords: merged });
  dispatch(updateBusinessKeywords(merged));
  return merged;
}
